import { FC, memo } from 'react';

import { InlineMath } from 'react-katex';
import cx from 'classnames';

import { TCalculatorMode } from '@src/types';

import { convertToLatex } from '../../utils';
import { useCalculatorDisplay } from './useCalculatorDisplay';

import ConverterDisplay from './partials/Converter/ConverterDisplay';

import styles from '../../calculator.module.scss';

interface IProps {
  value: string;
  operation: string | null;
  error: string | null;
  mode?: TCalculatorMode;
  isReadOnly?: boolean;
}

const CalculatorDisplay: FC<IProps> = ({ value, operation, error, mode, isReadOnly }) => {
  const { sizeClass } = useCalculatorDisplay(value);

  const shouldUseKatex = (mode === 'scientific' || mode === 'basic') && !error;

  if (mode === 'converter') {
    return <ConverterDisplay isReadOnly={isReadOnly} value={value} error={error} sizeClass={sizeClass} />;
  }

  return (
    <div className={cx(styles.display, mode)}>
      {operation && (
        <div className={styles.displayExpression}>
          <InlineMath math={convertToLatex(operation)} />
        </div>
      )}
      <div className={cx(styles.displayMain, sizeClass)}>
        {error ? error : shouldUseKatex ? <InlineMath math={convertToLatex(value)} /> : value}
      </div>
    </div>
  );
};

export default memo(CalculatorDisplay);
